<template>
    <div>
        <div class="gl_listWrapBar" @click="clkNews(item)" v-for="(item,index) in datapageList.slice(0,5)" :key="index">
            <div class="gl_imgList">
                <img :src="item.img">
            </div>
            <a href="#" class="gl_listItem">
                <div class="gl_listItemTitle">
                    {{item.title}}
                </div>
                <div class="gl_listItemSub">
                    {{ellipsis(item.abstracts,100)}}
                </div>
                <div class="display_between marginTop10">
                    <div>
                        <span v-bind:class="calculate(index)" class="gl_gree_block" v-for="(t,index) in (item.labelname || '').split(',')" :key="index" @click="labelclick(t)">
                            <span v-if="t!=''">{{t}}</span>
                        </span>
                    </div>
                    <div class="gl_inforshow">
                        <span class="marginRight20">{{formatTime(item.ptime,'YYYY/MM/DD')}}</span>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
import format from '@/assets/unit/unit.js'
export default {
    name: 'inTagInfor',
    props: ['datapageList'],
    data() {
        return {
            colorList: ['gl_gree_block', 'gl_red_block', 'gl_blue_block'],
        }
    },
    created() {},
    methods: {
        calculate(index) {
            var nm = this.colorList[Math.floor(index % 3)]
            return nm
        },
        //新闻的点击事件
        // clkNews(info) {
        clkNews(info) {
            //如果外连接存在，跳转外链，否则跳转详情
            if (Object.keys(info.address).length == 0) {
                const { href } = this.$router.resolve({
                    path: '/home/inforDetails?',
                    query: {
                        id: info.id,
                        column_Type: info.c_id,
                    },
                })
                window.open(href, '_blank')
            } else {
                window.open(info.address)
            }
        },
        formatTime(datatime, timeformat) {
            return format(datatime, timeformat)
        },
    },
}
</script>

<style scoped>
.gl_imgList img {
    width: 155px;
    height: 87px;
}
</style>
